import { AudioContext } from '@/contexts/AudioContext';
import { AudioContextValue } from '@/contexts/AudioContext/types';
import { useContext } from 'react';

export const useAudioContext = (): AudioContextValue => {
  const consumedContext = useContext(AudioContext);

  if (!consumedContext) throw new Error('AudioContext not found');

  const {
    init,
    loadAndPlaySound,
    pauseSound,
    stopSound,
    unloadSound,
    changeAudioPosition,
    moveBack,
    context,
    resetContext,
  } = consumedContext;

  return {
    init,
    loadAndPlaySound,
    pauseSound,
    stopSound,
    unloadSound,
    changeAudioPosition,
    moveBack,
    context,
    resetContext,
  };
};
